const messages = {
  dashboard: {
    title: "Nadzorna plošča storitve",
    description:
      "Srčno dobrodošli na vaši nadzorni plošči. Tu lahko pregledate trenutne kazalnike in sodelujoča podjetja iz vaše baze strank.",
    overview: {
      title: "Pregled sodelujočih strank",
      description:
        'Podjetja, ki so se registrirala na BRIDGESTONE <span class="text-danger">PLUS</span> in jih lahko povežemo z vami preko številke stranke.',
      month: "Novo ta mesec",
      year: "Novo to leto",
      all: "Skupaj",
    },
    credits: {
      title: "Knjiženje točk",
      description:
        "Nagradne točke dodeljene sodelujočim na podlagi posredovanih podatkov o prodaji.",
      month: "Prejšnji mesec",
      year: "Trenutno leto",
      prev_year: "Skupaj",
      allDealers: "Vse točke trgovcev",
      allPoints: "Vse točke",
      prev_month: "Prejšnji mesec",
    },
    details: {
      title: "Sodelujoče stranke podrobno",
      description:
        'Spodaj so navedena podjetja, ki so se registrirala na BRIDGESTONE <span class="text-danger">PLUS</span> z Bridgestone številko stranke in so vam dodeljena kot odgovornemu. Enostavno uporabite funkcije razvrščanja za drugačen vrstni red ali funkcijo iskanja.<br/><br/> <b>Opomba:</b> Če kliknete na stanje točk, boste prišli do podrobnega izvještaja računa.',
    },
    lastImport:
      'Zadnji uvoz podatkov o prodaji: <br/> <span class="text-danger">{date}</span>',
    kickback: {
      description:
        "Sodelujočim se kešbek provizije knjižijo na podlagi posredovanih podatkov o prihodkih.",
    },
    tyres: {
      title: "Pnevmatike",
      description: "Pnevmatike, kupljene s strani udeležencev programa",
    },
    short:
      "Dobrodošli na vaši nadzorni plošči. Tu lahko pregledate trenutne podatke in sodelujoča podjetja iz vaše baze strank.",
    headers: {
      city: "Mesto",
      company: "Podjetje",
      current_points: "trenutne točke",
      customer_number: "številka stranke",
      details: "podrobnosti",
      last_login: "Zadnja prijava",
      name: "ime",
      postal_code: "Poštna številka",
      street: "ulica",
      email: "E-naslov",
    },
    reload: "Ponovno naloži",
    exports: {
      title: "Izvožene Excel datoteke",
      downloadExcel: "Prenesi Excel",
      running: "V teku",
      head: {
        name: "Naziv",
        status: "Status",
      },
    },
  },
};
export default {
  messages,
};
